import {
    SetLoadTagsBulkInput,
    SetLoadTagsBulkResponse,
    ClientLoadTag,
    CreateLoadTagInput,
    ListLoadTagsResponse,
    SetLoadTagsInput,
    SetLoadTagsResponse,
    UpdateLoadTagInput,
} from '@numeo/types-main-web-app'
import axios from 'axios'
import { getApiBaseUrlWithoutV1 } from '@/setup/SetupAxios'

const request = () => ({ baseURL: getApiBaseUrlWithoutV1() })

/** Every success response of the load-tags routes is `{ success: true, data }`. */
interface Envelope<T> {
    success: true
    data: T
}

/** What a load-tags route answers on failure: its own message, or the shared validation answer with one entry per field that failed. */
interface FailureBody {
    message?: string
    errors?: Array<{ message?: string }>
}

/** The message to show for a failed load-tags request: the first field message of a rejected body, else the server's message, else `fallback`. */
export const getLoadTagsErrorMessage = (error: unknown, fallback: string): string => {
    const body = (error as { response?: { data?: FailureBody } })?.response?.data
    return body?.errors?.[0]?.message || body?.message || fallback
}

export const loadTagsApi = {
    async list(): Promise<ClientLoadTag[]> {
        const response = await axios.get<Envelope<ListLoadTagsResponse>>('/updater/load-tags/v1', request())
        return response.data.data.tags
    },

    async create(input: CreateLoadTagInput): Promise<ClientLoadTag> {
        const response = await axios.post<Envelope<ClientLoadTag>>('/updater/load-tags/v1', input, request())
        return response.data.data
    },

    async update(tagId: string, input: UpdateLoadTagInput): Promise<ClientLoadTag> {
        const response = await axios.patch<Envelope<ClientLoadTag>>(`/updater/load-tags/${tagId}/v1`, input, request())
        return response.data.data
    },

    async remove(tagId: string): Promise<void> {
        await axios.delete(`/updater/load-tags/${tagId}/v1`, request())
    },

    async setLoadTagsBulk(input: SetLoadTagsBulkInput): Promise<SetLoadTagsBulkResponse> {
        const response = await axios.put<Envelope<SetLoadTagsBulkResponse>>('/updater/load-tags/assignments/bulk/v1', input, { ...request(), timeout: 30000 })
        return response.data.data
    },

    async setLoadTags(loadId: string, input: SetLoadTagsInput): Promise<SetLoadTagsResponse> {
        const response = await axios.put<Envelope<SetLoadTagsResponse>>(`/updater/load-tags/assignments/${loadId}/v1`, input, request())
        return response.data.data
    },
}
